import React from 'react'
import ProfessionalUserAnalytics from './ProfessionalUserAnalytics';
import ProfessionalsAnalytics from './ProfessionalsAnalytics';
import { AdminPage, ViewSwitch, useViewParam } from './AdminAnalyticsUI';

const VIEWS = [
  { key: 'analytics', label: 'Professionals analytics' },
  { key: 'list', label: 'Professionals list' },
];

function AnalyticsProfessional({setActivePanel, activePanel}) {
  const [view, setView] = useViewParam();
  return (
    <AdminPage setActivePanel={setActivePanel} activePanel={activePanel}>
      <div style={{ marginBottom: '26px' }}>
        <ViewSwitch options={VIEWS} value={view} onChange={setView} />
      </div>
      {view === 'analytics' ? <ProfessionalsAnalytics/> : <ProfessionalUserAnalytics/>}
    </AdminPage>
  )
}

export default AnalyticsProfessional
